import styled from "@emotion/styled";

import { theme, transientOptions } from "shared/lib/styles";

export const Container = styled("div", { ...transientOptions })`
  grid-area: google-news-button;

  display: flex;

  margin-block-start: 20px;

  text-align: start;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 0;
    margin-inline-start: 4px;
  }
`;

export const GoogleNewsButton = styled("button", { ...transientOptions })`
  display: flex;
  gap: 6px;
  align-items: center;

  padding-block: 6px;
  padding-inline: 8px;

  color: #ffffff;
  font-weight: 500;
  font-size: 16px;

  border: none;
  border-radius: 4px;

  background: #f7f7f7;

  cursor: pointer;
`;

export const GoogleNewsIcon = styled("span", { ...transientOptions })`
  flex-shrink: 0;

  inline-size: 24px;
  block-size: 24px;
`;

export const TextContent = styled("span", { ...transientOptions })`
  color: #333333;
  font-size: 12px;
  font-family: Roboto;
  line-height: normal;
  white-space: nowrap;
`;

export const ImageGoogle = styled.img`
  display: block;

  inline-size: 16px;
  block-size: 16px;
`;
